import {Injectable} from '@angular/core';
import {Subject, Observable} from 'rxjs';

export interface AlertMessage {
  type: 'success' | 'info' | 'warning' | 'danger';
  msg: string;
  timeout?: number;
  toast?: boolean;
  scoped?: boolean;
  position?: string;
}

/**
 * Lightweight shim mimicking the subset of the old ng-jhipster JhiAlertService API
 * that the application code relies on (method signatures w/ 3 params, addAlert, isToast, get()).
 */
@Injectable({providedIn: 'root'})
export class JhiAlertService {
  private alerts: AlertMessage[] = [];
  private alerts$ = new Subject<AlertMessage>();
  private toast = false; // could be toggled via future config if needed

  /**
   * Return underlying alerts array (legacy code expects array not observable in some places).
   * For new code prefer subscribing to the observable.
   */
  get(): any {
    return this.alerts; // maintain legacy expectation of an array
  }

  asObservable(): Observable<AlertMessage> {
    return this.alerts$.asObservable();
  }

  isToast(): boolean {
    return this.toast;
  }

  // Legacy signatures accepted: (msg, params?, timeout?) though params ignored in shim
  success(msg: string, _params?: any, timeout: number = 5000): void {
    this.push({type: 'success', msg, timeout});
  }
  info(msg: string, _params?: any, timeout: number = 5000): void {
    this.push({type: 'info', msg, timeout});
  }
  warning(msg: string, _params?: any, timeout: number = 5000): void {
    this.push({type: 'warning', msg, timeout});
  }
  error(msg: string, _params?: any, timeout: number = 5000): void {
    this.push({type: 'danger', msg, timeout});
  }

  /** Add alert resembling original addAlert(alertOptions, alertsArray) */
  addAlert(alert: AlertMessage, alerts: AlertMessage[]): AlertMessage {
    alerts.push(alert);
    this.alerts$.next(alert);
    return alert;
  }

  private push(alert: AlertMessage) {
    this.alerts.push(alert);
    this.alerts$.next(alert);
  }
}
